document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.cart-upsell-btn');
  if (!btn) return;

  const originalText = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding...';

  try {
    // 1. Add the upsell item to the cart
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: 57277626908937,
        quantity: 1
      })
    });

    if (!addResponse.ok) {
      const errorData = await addResponse.json();
      throw new Error(errorData.description || 'Could not add item to cart');
    }

    // 2. Re-fetch the current page so we get a freshly rendered cart drawer
    const pageResponse = await fetch(window.location.href);
    const pageHtml = await pageResponse.text();

    const parser = new DOMParser();
    const newDoc = parser.parseFromString(pageHtml, 'text/html');
    const newDrawer = newDoc.querySelector('cart-drawer');
    const currentDrawer = document.querySelector('cart-drawer');

    if (newDrawer && currentDrawer) {
      // Swap the old drawer markup for the new one
      currentDrawer.replaceWith(newDrawer);

      // Re-open the drawer so the user sees the updated cart
      if (typeof newDrawer.open === 'function') {
        newDrawer.open();
      } else {
        newDrawer.classList.remove('is-empty');
        const overlay = newDrawer.querySelector('#CartDrawer-Overlay');
        if (overlay) newDrawer.classList.add('active');
      }
    } else {
      // Fallback if anything about the swap fails
      location.reload();
    }
  } catch (error) {
    alert(error.message);
  } finally {
    btn.disabled = false;
    btn.textContent = originalText;
  }
});